import { MenuOptionType } from "@dexteel/mesf-core";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { Edit as EditIcon } from "@mui/icons-material";
import { FileCopy as ContentCopyIcon } from "@mui/icons-material";
import { PlaylistAdd as PlaylistAddIcon } from "@mui/icons-material";
import { Commodity } from "../../../models/Commodity";

type Props = {
  setCommodity: (commodity: Commodity) => void;
  setShowModal: (modal: "new" | "edit" | "delete" | "") => void;
  handleNewCommodity: () => void;
};

export const useCommodityOptionsFunctions = ({
  setCommodity,
  setShowModal,
  handleNewCommodity,
}: Props) => {
  const getMenuOptions = (data: Commodity) => {
    let options: MenuOptionType[] = [];
    options = options.concat([
      {
        name: "New Commodity",
        key: "new_commodity",
        onClick: () => {
          handleNewCommodity();
        },
        icon: <PlaylistAddIcon />,
      },
    ]);
    if (data) {
      options = options.concat([
        {
          name: "Edit Commodity",
          key: "edit_commodity",
          onClick: () => {
            setCommodity(data);
            setShowModal("edit");
          },
          icon: <EditIcon />,
        },
        {
          name: "Delete Commodity",
          key: "delete_commodity",
          onClick: () => {
            setCommodity(data);
            setShowModal("delete");
          },
          icon: <DeleteIcon />,
        },
        {
          name: "Duplicate Commodity",
          key: "duplicate_commodity",
          onClick: () => {
            setCommodity({
              ...data,
              CommodityName: `${data.CommodityName} (Copy)`,
              IsDuplicate: true,
            });
            setShowModal("new");
          },
          icon: <ContentCopyIcon />,
        },
      ]);
    }
    return options;
  };
  return {
    getMenuOptions,
  };
};
